// @flow

import { makeApiCall } from '../../../../../services/apiService/apiService';
import { downloadArrayBufferAsXLS } from '../../../../../services/helpers';
import { downloadFileName } from '../bpPassbookDashboardHelper';

export const bpPassbookDashboardActions = {
  GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
  FILTER_DASHBOARD_DATA: 'FILTER_BP_DASHBOARD_DATA',
  GET_SUMMARY_DATA: 'GET_SUMMARY_DATA',
  GET_BALANCE_DATA: 'GET_BALANCE_DATA'
};

export const getDashboardDataAction = (load: Object) => ({
  type: bpPassbookDashboardActions.GET_DASHBOARD_DATA,
  payload: load
});

export const getSummaryDataAction = (load: Object) => ({
  type: bpPassbookDashboardActions.GET_SUMMARY_DATA,
  payload: load
});

export const getBalanceDataAction = (load: Object) => ({
  type: bpPassbookDashboardActions.GET_BALANCE_DATA,
  payload: load
});

export const filterDashboardData = (load: Object) => ({
  type: bpPassbookDashboardActions.FILTER_DASHBOARD_DATA,
  payload: load
});

const getSummaryDataFailureAction = () => (dispatch: Function) => {
  dispatch(
    getSummaryDataAction({
      summaryData: null
    })
  );
};

const getDashboardDataFailureAction = () => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isLoading: false,
      isLoaded: true,
      dashboardData: [],
      dashboardDataFiltered: []
    })
  );
};

const getBalanceDataFailureAction = () => (dispatch: Function) => {
  dispatch(
    getBalanceDataAction({
      balanceData: null
    })
  );
};

export const getSummaryData = obj => (dispatch: Function) => {
  dispatch(getSummaryDataFailureAction());
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bpSummary',
    method: 'GET',
    replaceParamsArr: [
      { key: 'fromDateTime', val: obj.fromDateTime },
      { key: 'toDateTime', val: obj.toDateTime }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getSummaryDataAction({
            summaryData: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getSummaryDataAction ', res);
        dispatch(getSummaryDataFailureAction());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getSummaryDataAction ', res);
      dispatch(getSummaryDataFailureAction());
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getSummaryDataAction ', res);
      dispatch(getSummaryDataFailureAction());
    }
  };

  return makeApiCall(requestObj);
};

export const downloadData = obj => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bpTransactionsDownload',
    method: 'GET',
    replaceParamsArr: [
      { key: 'fromDateTime', val: obj.fromDateTime },
      { key: 'toDateTime', val: obj.toDateTime },
      { key: 'transactionType', val: obj.transactionType }
    ],
    contentType: 'application/xml',
    responseType: 'arraybuffer',
    successCb: res => {
      // eslint-disable-next-line no-console
      const reportName = downloadFileName;
      downloadArrayBufferAsXLS(res, reportName);
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getDashboardDataAction ', res);
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getDashboardDataAction ', res);
    }
  };
  return makeApiCall(requestObj);
};

export const getDashboardData = obj => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false,
      dashboardData: [],
      dashboardDataFiltered: []
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bpTransactions',
    method: 'GET',
    replaceParamsArr: [
      { key: 'fromDateTime', val: obj.fromDateTime },
      { key: 'toDateTime', val: obj.toDateTime },
      { key: 'transactionType', val: obj.transactionType }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload,
            dashboardDataFiltered: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getDashboardDataAction ', res);
        dispatch(getDashboardDataFailureAction());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getDashboardDataAction ', res);
      dispatch(getDashboardDataFailureAction());
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getDashboardDataAction ', res);
      dispatch(getDashboardDataFailureAction());
    }
  };

  return makeApiCall(requestObj);
};

export const getBalanceData = () => (dispatch: Function) => {
  dispatch(getBalanceDataFailureAction());
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bpBalance',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getBalanceDataAction({
            balanceData: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getBalanceDataAction ', res);
        dispatch(getBalanceDataFailureAction());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getBalanceDataAction ', res);
      dispatch(getBalanceDataFailureAction());
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getBalanceDataAction ', res);
      dispatch(getBalanceDataFailureAction());
    }
  };

  return makeApiCall(requestObj);
};
